/**
 * Constantes et configuration pour la calculatrice AEP
 * ELECTRON INDUSTRIE - Bureau d'études Industrie Mécanique
 */

// Logo Electron Industrie
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_pressure-flow-calc/artifacts/fri9fbwq_ELECTRON%20INDUSTRIE%20PPT.png";

// Pression aval minimale imposée (seuil de service)
export const PRESSION_AVAL_MIN = 3;

// Limites de pression
export const MIN_PRESSURE_BARS = 1;
export const MAX_PRESSURE_BARS = 12;

// Pressions amont disponibles (1 à 12 bars)
export const PRESSIONS_AMONT = Array.from(
  { length: MAX_PRESSURE_BARS - MIN_PRESSURE_BARS + 1 }, 
  (_, i) => i + MIN_PRESSURE_BARS
);

// Débits selon l'unité
export const DEBITS_LMIN = [1, 10, 20, 50, 100];
export const DEBITS_M3H = [1, 5, 10, 50, 100];

// Rendements disponibles (en pourcentage)
export const RENDEMENTS = [50, 60, 70, 80];

// Constantes temporelles
export const HOURS_PER_DAY = 24;
export const DAYS_PER_MONTH = 30;
export const DAYS_PER_YEAR = 365;

// Modes de durée avec leurs heures associées
export const MODES_DUREE = {
  '1h': { label: '1 heure', heures: 1 },
  '4h': { label: '4 heures', heures: 4 },
  '8h': { label: '8 heures', heures: 8 },
  '12h': { label: '12 heures', heures: 12 },
  journalier: { label: 'Journalier (24h)', heures: HOURS_PER_DAY },
  mensuel: { label: 'Mensuel', heures: HOURS_PER_DAY * DAYS_PER_MONTH },
  annuel: { label: 'Annuel', heures: HOURS_PER_DAY * DAYS_PER_YEAR }
};

// Tarifs énergétiques (€/kWh)
export const TARIFS = {
  venteEDF: 0.04,           // 4 centimes d'euro par kWh
  autoconsommation: 0.19    // 19 centimes d'euro par kWh
};

// Valeurs par défaut
export const DEFAULTS = {
  pressionAmont: 4,
  unite: 'm3h',
  debit: 10,
  rendement: 50,
  mode: 'journalier'
};

// Coefficients de calcul de puissance
export const COEFF_M3H = 27.78;
export const COEFF_LMIN = 1.667;
